module.exports = __webpack_public_path__ + "img/VM.bb4a96ed.png";